import { createMuiTheme } from "@material-ui/core"
import { FontType } from "../common/TextUtils"

// TODO phase this out in favor of MUI theme.spacing
export const spacing = (spacingAmount = 1) => spacingAmount * 8

export const appTheme = createMuiTheme({
    typography: {
        fontFamily: FontType.ROBOTO,
        h1: {
            fontFamily: FontType.ARCHIVO_BLACK,
        },
        h2: {
            fontFamily: FontType.ARCHIVO_BLACK,
        },
        h4: {
            fontFamily: FontType.ARCHIVO_BLACK,
        },
        h5: {
            fontWeight: "bold",
        },
        h6: {
            fontWeight: "normal",
        },
        body2: {
            color: "#00000099"
        },
        subtitle1: {
            lineHeight: 1.5,
            letterSpacing: "0.2px",
        },
        subtitle2: {
            fontFamily: FontType.ARCHIVO_BLACK,
        },
        overline: {
            letterSpacing: 1.5,
            color: "#00000099",
            fontWeight: 500,
            fontSize: 12
        }
    },

    palette: {
        common: {black: "#000", white: "#fff"},
        background: {paper: "#fafafa", default: "#fff"},
        primary: {
            main: "#2d67ca",
        },
        secondary: {
            main: "#FCCF2E",
        },
        error: {
            main: "#b00020",
        }
    },
    overrides: {
        MuiPaper: {
            root: {
                border: "solid 1px #0000001e",
            }
        },
        MuiFab: {
            label: {
                fontWeight: "bold",
                lineHeight: "16px",
                letterSpacing: "1.3px",
                paddingLeft: 16,
                paddingRight: 16
            }
        },
        MuiButton: {
            label: {
                fontWeight: "bold",
                lineHeight: "16px",
                letterSpacing: "1.3px",
                paddingLeft: 8,
                paddingRight: 8
            }
        }
    },
    props: {
        MuiPaper: {
            elevation: 0,
        },
        MuiCard: {
            elevation: 0
        },
        MuiFab: {
            size: "small",
            variant: "extended"

        },
        MuiTextField: {
            variant: "outlined",
            InputLabelProps: {
                required: false
            }
        }
    }
})
